import { render } from "./allFacilities.vue?vue&type=template&id=1bd96c0a&scoped=true"
import script from "./allFacilities.vue?vue&type=script&lang=js"
export * from "./allFacilities.vue?vue&type=script&lang=js"

import "./allFacilities.vue?vue&type=style&index=0&id=1bd96c0a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bd96c0a"]])

export default __exports__